import z from "zod";

const knockErrorTypeValues = ["UNKNOWN", "UNSUPPORTED_CHANNEL"] as const;
const knockErrorTypeSchema = z.enum(knockErrorTypeValues);
const KnockErrorType = knockErrorTypeSchema.enum;
type KnockErrorType = z.infer<typeof knockErrorTypeSchema>;

export type KnockErrors =
  | { errorType: typeof KnockErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof KnockErrorType.UNSUPPORTED_CHANNEL; data: { channel: string; supportedChannels?: string[] } };

export const knockErrorDetails: Record<KnockErrorType, { sentryDescription: string }> = {
  UNKNOWN: { sentryDescription: "Unknown Knock Error" },
  UNSUPPORTED_CHANNEL: { sentryDescription: "Notification channel not supported by Knock" },
};
